<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Cotton & Basic Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Cotton & Basic Line" file="cotton">
                싱글/더블 니트와 립, 테리, 트리코트, BCI 코튼 US 코튼, 유기농 코튼, 실켓 코튼과 더불어 다양한 혼방 섬유를 다룹니다. 고급스러운 코튼 원단부터 합리적인 가격의 옵션까지 커버하는 베이직 니트 아이템을 생산합니다.
            </sub-product>
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped></style>
